<template>
  <div class="history-page">
    <CCol sm="12" class="bg-white">
      <CRow class="header-bar">
        <CButton class="back-btn" aria-label="Go back" @click="goBack">
          <svg viewBox="0 0 24 24" class="icon-back">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </CButton>
        <h2 class="center-title">History</h2>
        <button
          class="right-actions"
          @click="refreshHistories"
          aria-label="Refresh"
        >
          <img
            src="../assets/img/refresh.png"
            class="icon-refresh"
            alt="Refresh"
          />
        </button>
      </CRow>

      <div class="content text-center" style="max-width:500px;margin:0 auto">
        <div
          v-for="item in collectRewardDetails"
          :key="item.id"
          class="history-card"
          @click="openStatusModal(item)"
        >
          <div class="hc-left">
            <div class="hc-icon">
              <img
                :src="getCategoryIcon(item.category)"
                width="20"
                height="20"
              />
            </div>
          </div>

          <div class="hc-mid">
            <div
              class="hc-type"
              :class="{
                'text-danger':
                  item.category === 'Redeem' || item.category === 'Exchange',
              }"
            >
              {{
                item.category === "Redeem" || item.category === "Exchange"
                  ? "Redeem/Exchange"
                  : "Collect Point"
              }}
            </div>
            <div class="hc-brand">{{ item.companyName }}</div>
            <div class="hc-meta">
              {{ item.created_date | moment("DD/MM/YYYY") }}
              <span class="hc-dot"></span>
              {{ item.created_date | moment("HH:mm") }}
            </div>
          </div>

          <div class="hc-right">
            <div class="hc-value">
              <img
                v-if="
                  item.category !== 'Redeem' && item.category !== 'Exchange'
                "
                src="../assets/img/coin-purple.png"
                width="20"
                height="20"
              />
              <img
                v-else
                src="../assets/img/iconexchange.png"
                width="20"
                height="20"
              />
              <span
                >{{
                  item.category === "Redeem" || item.category === "Exchange"
                    ? "-"
                    : "+"
                }}{{ item.values }}</span
              >
            </div>
            <div
              v-if="prettyStatus(item)"
              class="hc-status"
              :class="badgeClass(prettyStatus(item))"
            >
              {{
                prettyStatus(item)
                  .charAt(0)
                  .toUpperCase() + prettyStatus(item).slice(1)
              }}
            </div>
          </div>
        </div>

        <h3 class="mt-4 mb-3 font-color-171717 text-left">Redeem Status</h3>

        <div
          v-if="exchangeDetails.length === 0"
          class="text-center text-muted p-3"
        >
          No exchange for now
        </div>

        <div
          v-for="item in exchangeDetails"
          :key="item.id"
          class="history-card"
          @click="openStatusModal(item)"
        >
          <div class="hc-left">
            <div class="hc-icon">
              <img
                :src="getCategoryIcon(item.category)"
                width="20"
                height="20"
              />
            </div>
          </div>

          <div class="hc-mid">
            <div class="hc-type text-danger">Redeem Point</div>
            <div class="hc-brand">{{ item.companyName }}</div>
            <div class="hc-meta">
              {{ item.created_date | moment("DD/MM/YYYY") }}
              <span class="hc-dot"></span>
              {{ item.created_date | moment("HH:mm") }}
            </div>
          </div>

          <div class="hc-right">
            <div class="hc-value">
              <img
                src="../assets/img/iconexchange.png"
                width="20"
                height="20"
              />
              <span>-{{ item.values }}</span>
            </div>
            <div
              v-if="prettyStatus(item)"
              class="hc-status"
              :class="badgeClass(prettyStatus(item))"
            >
              {{
                prettyStatus(item)
                  .charAt(0)
                  .toUpperCase() + prettyStatus(item).slice(1)
              }}
            </div>
          </div>
        </div>
      </div>
    </CCol>

    <div class="footer-bottom bg-white">
      <CRow class="justify-content-center mb-2">
        <CCol style="display:flex;align-items:center;justify-content:center">
          <CCol sm="12" lg="12">
            <CCol
              sm="12"
              lg="12"
              style="display:flex;align-items:center;justify-content:center;left:0;right:0;position:fixed;bottom:0;background-color:#fff;padding-bottom:3px;padding-top:5px;"
            >
              <CCol sm="2" lg="2" class="p-0 m-0" style="flex:1">
                <CCol @click="GoHome">
                  <div class="text-center">
                    <img
                      src="../assets/img/navigation/navigation/home.png"
                      class="btn-active"
                      style="width:24px"
                    />
                    <br />
                    <label class="text-non-active" style="color:#D0D5DD"
                      >Home</label
                    >
                  </div>
                </CCol>
              </CCol>
              <CCol sm="2" lg="2" class="p-0 m-0" style="flex:1">
                <CCol @click="GoToSearch">
                  <div class="text-center">
                    <img
                      src="../assets/img/navigation/navigation/search-normal.png"
                      style="width:24px"
                    />
                    <br />
                    <label class="text-non-active" style="color:#D0D5DD"
                      >Search</label
                    >
                  </div>
                </CCol>
              </CCol>
              <CCol
                sm="2"
                lg="2"
                class="p-0 m-0"
                style="flex:1;position:relative;"
              >
                <CCol @click="startScanner">
                  <img
                    src="../assets/img/scan.png"
                    style="width:50px;position:absolute;bottom:5px;left:50%;transform:translateX(-50%);border:5px solid white;border-radius:50%;"
                  />
                </CCol>
              </CCol>
              <CCol sm="2" lg="2" class="p-0 m-0" style="flex:1">
                <CCol @click="GoInbox">
                  <div class="text-center">
                    <img
                      src="../assets/img/navigation/navigation/notification.png"
                      style="width:24px"
                    />
                    <br />
                    <label class="text-non-active" style="color:#D0D5DD"
                      >Inbox</label
                    >
                  </div>
                </CCol>
              </CCol>
              <CCol sm="2" lg="2" class="p-0 m-0" style="flex:1">
                <CCol @click="GoProfile">
                  <div class="text-center">
                    <img
                      src="../assets/img/navigation/navigation/user.png"
                      style="width:24px"
                    />
                    <br />
                    <label class="text-non-active" style="color:#D0D5DD"
                      >Profile</label
                    >
                  </div>
                </CCol>
              </CCol>
            </CCol>
          </CCol>
        </CCol>
      </CRow>
    </div>

    <div
      v-if="showApproval"
      class="modal-overlay"
      role="dialog"
      aria-modal="true"
      @click.self="showApproval = false"
    >
      <div class="modal-sheet">
        <img src="@/assets/img/new/Illustration-email.png" class="email-img" />
        <h3 class="modal-title">Waiting for Approval</h3>
        <p class="modal-desc">
          Please hold on while the cashier reviews your request. This may take a
          moment.
        </p>
        <p class="modal-italic">Please wait a moment...</p>
        <button class="modal-btn" @click="closeAllPopups">Close</button>
      </div>
    </div>

    <div
      v-if="showFailed"
      class="modal-overlay"
      role="dialog"
      aria-modal="true"
      @click.self="showFailed = false"
    >
      <div class="modal-sheet">
        <img
          src="@/assets/img/new/Illustration-rejected.png"
          class="rejected-img"
        />
        <h3>Rejected by Cashier</h3>
        <p>Your reward request has been rejected by the cashier.</p>
        <button
          class="modal-btn"
          style="background-color:#F45353"
          @click="closeAllPopups"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Html5Qrcode } from "html5-qrcode";

export default {
  name: "HistoryPage",
  data() {
    return {
      histories: [],
      user: {},
      showApproval: false,
      showFailed: false,
      selectedDetail: null,
      qrScanner: null,
    };
  },
  async mounted() {
    await this.GetInfoUser();
  },
  methods: {
    async GetInfoUser() {
      try {
        const response = await this.$API.get(this.$LoginUserDetail, {
          withCredentials: true,
        });
        if (response.status === 200) {
          this.user = response.data;
          await this.GetHistory(this.user.id);
        }
      } catch (e) {
        console.error(e);
      }
    },
    async GetHistory(id) {
      try {
        const response = await this.$API.get(
          this.$UserHisstoryLogs + "?userId=" + id
        );
        if (response.status === 200) {
          const rawHistories = Array.isArray(response.data) ? response.data : [];

          this.histories = rawHistories.map((item, index) => ({
            id: item.Id || index,
            companyName: item.CompanyName || item.CompanyId,
            companyId: item.CompanyId,
            category: item.Category || "Collect",
            values: item.PointValues || 0,
            status: item.Status || "pending",
            created_date: item.CreatedDate,
            title: item.Title,
            statusText: item.Status,
            status_name: item.Status,
            StatusName: item.Status,
          }));
        }
      } catch (e) {
        console.error(e);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async refreshHistories() {
      if (!this.user?.id) return;
      await this.GetHistory(this.user.id);
    },
    // prettyStatus(detail) {
    //   if (detail.category === "Redeem" || detail.category === "Exchange")
    //     return "";
    //   const raw = String(
    //     detail.statusText ??
    //       detail.status_name ??
    //       detail.StatusName ??
    //       detail.status ??
    //       ""
    //   )
    //     .trim()
    //     .toLowerCase();
    //   if (
    //     [
    //       "claimed",
    //       "pending",
    //       "collecting",
    //       "ready",
    //       "failed",
    //       "approved",
    //     ].includes(raw)
    //   )
    //     return raw;
    //   if (detail.status === true) return "claimed";
    //   if (detail.status === false) return "pending";
    //   return "";
    // },
    prettyStatus(detail) {
  // ❌ remove this condition:
  // if (detail.category === "Redeem" || detail.category === "Exchange") return "";

  const raw = String(
    detail.statusText ??
      detail.status_name ??
      detail.StatusName ??
      detail.status ??
      ""
  )
    .trim()
    .toLowerCase();

  if (
    ["claimed", "pending", "collecting", "ready", "failed", "approved"].includes(
      raw
    )
  )
    return raw;

  if (detail.status === true) return "claimed";
  if (detail.status === false) return "pending";
  return "";
},
    badgeClass(s) {
      switch (s) {
        case "claimed":
        case "ready":
        case "approved":
          return "badge-success";
        case "pending":
          return "badge-warning";
        case "collecting":
          return "badge-warning";
        case "failed":
          return "badge-danger";
        default:
          return "badge-neutral";
      }
    },
    getStatus(detail) {
      const raw = String(
        detail.statusText ||
          detail.status_name ||
          detail.StatusName ||
          detail.status ||
          ""
      )
        .trim()
        .toLowerCase();
      if (
        [
          "claimed",
          "pending",
          "collecting",
          "ready",
          "failed",
          "approved",
        ].includes(raw)
      )
        return raw;
      if (detail.status === true) return "claimed";
      if (detail.status === false) return "pending";
      return "pending";
    },
    isWaitingStatus(s) {
      return s === "pending" || s === "collecting";
    },
    openStatusModal(detail) {
  const s = this.getStatus(detail);

  // 1. Jika statusnya approved, terus redirect ke ClaimReward
  if (s === "approved") {
    this.$router.push({
  name: "ClaimReward",
  query: { companyId: detail.companyId || 'default' }
})
    return;
  }

  // 2. Jika status waiting → buka modal approval
  if (this.isWaitingStatus(s)) {
    this.showApproval = true;
    this.showFailed = false;
    this.selectedDetail = detail;
    return;
  }

  // 3. Jika status failed → buka modal failed
  if (s === "failed") {
    this.showFailed = true;
    this.showApproval = false;
    this.selectedDetail = detail;
    return;
  }

  // 4. Jika tidak masuk mana-mana → tutup semua popup
  this.closeAllPopups();
},
    closeAllPopups() {
      this.showApproval = false;
      this.showFailed = false;
      this.selectedDetail = null;
    },
    startScanner() {
      if (!document.getElementById("qr-reader")) return;
      this.qrScanner = new Html5Qrcode("qr-reader");
      this.qrScanner
        .start({ facingMode: "environment" }, { fps: 10, qrbox: 250 }, () => {})
        .catch(() => {});
    },
    GoHome() {
      this.$router.push("Home");
    },
    GoToSearch() {
      this.$router.push("/Search");
    },
    GoInbox() {
      this.$router.push("/Notification");
    },
    GoProfile() {
      this.$router.push("/Setting");
    },
  },
  computed: {
    getCategoryIcon() {
      return (category) => {
        if (category === "Redeem")
          return require("../assets/img/iconexchange.png");
        if (category === "Reward")
          return require("../assets/img/purple-coffee.png");
        return require("../assets/img/coin.png");
      };
    },
    collectRewardDetails() {
      if (!Array.isArray(this.histories)) return [];
      // Filter untuk Collect dan Reward
      return this.histories.filter(
        (d) => d.category === "Collect" || d.category === "Reward"
      );
    },
    exchangeDetails() {
      if (!Array.isArray(this.histories)) return [];
      // Filter untuk Redeem dan Exchange
      return this.histories.filter(
        (d) => d.category === "Redeem" || d.category === "Exchange"
      );
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.cdnfonts.com/css/general-sans");
body {
  top: 0 !important;
  font-family: "General Sans", sans-serif;
}
.header-bar {
  position: relative;
  height: 75px;
  display: block;
  margin-bottom: 12px;
}

.back-btn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: #111827;
  cursor: pointer;
}

.icon-back {
  width: 22px;
  height: 22px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.center-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.right-actions {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.icon-refresh {
  width: 22px;
  height: 22px;
  display: block;
}

.history-page {
  min-height: 100vh;
  display: -webkit-box;
  -webkit-box-direction: normal;
  flex-direction: column;
}
.content {
  flex: 1;
  padding-bottom: 80px;
}
.history-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  padding: 12px 14px;
  margin-bottom: 12px;
}

.hc-left {
  width: 44px;
  display: flex;
  justify-content: center;
}
.hc-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #f7f8fc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hc-mid {
  flex: 1;
  min-width: 0;
}
.hc-type {
  font-size: 12px;
  line-height: 1;
  color: #928afd;
  font-weight: 600;
  text-align: left;
}
.hc-brand {
  font-size: 14px;
  color: #171717;
  font-weight: 700;
  text-align: left;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hc-meta {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.hc-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #d1d5db;
  display: inline-block;
}

.hc-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}
.hc-value {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: #171717;
}

.hc-status {
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
.badge-success {
  background: #e7f8eb;
  color: #22cc31;
}
.badge-warning {
  background: #fff7e6;
  color: #d97706;
}
.badge-danger {
  background: #fee2e2;
  color: #ef4444;
}
.badge-neutral {
  background: #f3f4f6;
  color: #6b7280;
}

.status-badge {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  text-transform: capitalize;
}
.badge-success {
  color: #22cc31;
  background-color: rgba(34, 204, 49, 0.1);
}
.badge-warning {
  color: #edba13;
  background-color: rgba(237, 200, 78, 0.1);
}
.badge-danger {
  color: #ef4444;
  background-color: rgba(239, 68, 68, 0.1);
}
.badge-neutral {
  color: #6b7280;
  background-color: #f3f4f6;
}
.clickable-card {
  cursor: pointer;
}
.email-img,
.rejected-img {
  width: 100%;
  height: 100%;
  margin: 18px auto;
}
.modal-italic {
  font-style: italic;
  color: #928afd;
  margin-top: -10px;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: flex-end;
  z-index: 999;
}
.modal-sheet {
  width: 100%;
  max-width: 520px;
  margin: 0 auto 16px;
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  text-align: center;
}
.modal-title {
  font-size: 20px;
  color: #1f2937;
  margin: 8px 0;
}
.modal-desc {
  color: #6b7280;
  margin: 0 0 6px;
}
.modal-btn {
  width: 100%;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  background: #928afd;
  color: #fff;
  font-weight: 600;
}
.footer-bottom {
  height: 64px;
}
</style>